import { createContext, useCallback, useMemo, useState } from 'react';

type StepperContextData = {
  activeStep: number;
  forwardStep: () => void;
  backwardStep: () => void;
};

const FIRST_STEP = 1;

const stepperContextDefaultValue: StepperContextData = {
  activeStep: FIRST_STEP,
  forwardStep: () => null,
  backwardStep: () => null,
};

export const StepperContext = createContext<StepperContextData>(stepperContextDefaultValue);

export const useStepperContextValue = (): StepperContextData => {
  const [activeStep, setActiveStep] = useState(FIRST_STEP);

  const forwardStep = useCallback((): void => {
    setActiveStep((step) => step + 1);
  }, []);

  const backwardStep = useCallback((): void => {
    setActiveStep((step) => step > FIRST_STEP ? step - 1 : FIRST_STEP);
  }, []);

  return useMemo(() => (
    {
      activeStep,
      forwardStep,
      backwardStep,
    }
  ), [activeStep]);
};
